module.exports = __webpack_public_path__ + "img/timelinetopnew.fa1e5a23.png";